export let dataProps = {
    id: 0, 
    coupon_code: '',
    discount_percent: 0,
    active: true,
    active_date_range: ['', ''],
    eligible_store_id: 0,
    discount_fixed_amount: 0,
    maximum_count: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/discountCoupon/properties.js